export const useIsElectron = () => !!window.electronAPI?.isElectron;
